// extracted by css-extract-rspack-plugin
export default {"unlimited-activations":"PromoCodeModal-module__unlimited-activations--JV1PD","unlimitedActivations":"PromoCodeModal-module__unlimited-activations--JV1PD"};